import React from 'react';
import { TextBadge } from '@/UIlibrary/TextBadge/TextBadge';
import { COLOR_TYPE } from '@/UIlibrary/globalTypes';
import { OnboardingStatus } from '@/graphql/__generated__/onboarding';
import { useTranslations } from 'use-intl';

interface OnboardingStatusBadgeProps {
	status: OnboardingStatus;
	size?: 'sm' | 'md' | 'lg';
}

export const OnboardingStatusBadge: React.FC<OnboardingStatusBadgeProps> = ({
	status,
	size = 'sm'
}) => {
	const t = useTranslations('Registries');

	// Map statuses to badge color types from your UI library
	const statusStyles: Record<OnboardingStatus, COLOR_TYPE> = {
		REJECTED: 'error',
		IN_PROCESS: 'primary',
		CORRECTIONS_REQUESTED: 'warning',
		PENDING_REVIEW: 'warning',
		APPROVED: 'success'
	};

	// Map statuses to display names using translations
	const statusDisplayNames: Record<OnboardingStatus, string> = {
		IN_PROCESS: t('InProcess'),
		CORRECTIONS_REQUESTED: t('CorrectionsRequested'),
		PENDING_REVIEW: t('PendingReview'),
		REJECTED: t('Rejected'),
		APPROVED: t('Approved')
	};

	const displayText = `${statusDisplayNames[status] || t('Status')}`;

	return <TextBadge text={displayText} size={size} type={statusStyles[status] || 'gray'} />;
};
